module.exports = __webpack_public_path__ + "img/20190916170412972.9614d1a5.jpg";